import { useCheckPermissions } from '@/shared';
import { SaveICE } from '../../shared/components';
import { PermissionsEnum } from '@/auth/interfaces';

export type CreateICEPageProps = {};

const CreateICEPage: React.FC<CreateICEPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_ice)

  return <SaveICE titlePage="Crear ICE" />;
};

export default CreateICEPage;
